<template>
  <div>
    <div class="item mt">
                <span class="icon">
                    <img src="../views/images/login/email.png" alt="" />
                </span>
      <input
          type="text"
          class="inp"
          v-model.trim="data.username"
          @input="onusername"
          :placeholder="$t('login.email')"
      />
    </div>
    <div class="item">
                <span class="icon"
                ><img src="../views/images/login/lock.png" alt=""
                /></span>
      <input
          :type="inputtype"
          class="inp"
          @input="onpassword"
          v-model.trim="data.password"
          :placeholder="$t('login.password')"
      />
      <div
          class="eye_bi"
          @click="showPwd"
          :class="inputtype == 'text' ? 'eye' : ''"
      ></div>
    </div>
  </div>

</template>

<script>

export default {
  name: "usertype",
  props:{
    username:{
      default:'',
      type:String
    },
    password:{
      default:'',
      type:String
    }
  },
  data(){
    return{
      inputtype: "password",
      data:{
        username:'',
        password:''
      }
    }
  },
  mounted() {
    this.data.username = this.username;
    this.data.password = this.password;
  },
  methods:{
    onConfirm(value, index) {
      this.countryIndex = index;
      this.countryCode = this.g_countryCode[this.countryIndex];
      this.showPicker = false;
    },
    showPwd() {
      if (this.inputtype == "password") {
        this.inputtype = "text";
      } else {
        this.inputtype = "password";
      }
    },
    onusername(){
      this.$emit('update:username',this.data.username);
    },
    onpassword(){
      this.$emit('update:password',this.data.password);
    }
  },

}
</script>

<style scoped  lang="less">
.mt {
  margin-top: 20px;
}

.item {
  height: 68px;
  border-bottom: 1px solid #f0f1f3;
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding-bottom: 4px;

.icon {
  width: 32px;
  height: 27px;

img {
  width: 100%;
  height: 100%;
}
}

input {
  height: 20px;
  margin-left: 7px;
  flex: 1;
  margin-bottom: 3px;
}
}
</style>
